import styles from "./style.module.scss";

export default function FullAccessSection() {
  return (
    <div className={styles.fullAccessWrapper}>
      <div className={styles.fullAccessContainer}>Full Access</div>
      <span className={styles.fullAccessDescription}>
        Because you are a Haul Pay Factoring user you have full access for free. Thank you!
      </span>
    </div>
  );
}
